import type { CustomerInvoiceTypes as cit } from '@/types/customer-invoice-types';

export const dateOptionsMap = {
  bookDt: 'bk',
  deptDt: 'dd',
  cutOffDt: 'ct',
} as const;

export const ShippingStatuses = {
  shipped: 'success',
  cancelled: 'danger',
  booked: 'info',
} as const;

export const freightTypeMap = {
  CIF: {
    showInsurance: true,
    showFreight: true,
    showForwarder: true,
  },
  CFR: {
    showInsurance: false,
    showFreight: true,
    showForwarder: true,
  },
  'C&I': {
    showInsurance: true,
    showFreight: false,
    showForwarder: true,
  },
  'C&F': {
    showInsurance: false,
    showFreight: true,
    showForwarder: true,
  },
  FOB: {
    showInsurance: false,
    showFreight: true,
    showForwarder: true,
  },
};

export const bookingStatusColors = {
  all: 'bg-blue-500',
  booked: 'bg-blue-900',
  cancelled: 'bg-red-500',
  shipped: 'bg-green-500',
} as const;

export const shippingStatusColors = {
  planned: 'bg-yellow-500',
  'cutoff ended': 'bg-red-900',
  'in transit': 'bg-blue-500',
  grounded: 'bg-orange-500',
} as const;

export const containerChargesMap = {
  totalLoadingCharge: 'loading_charge',
  totalForwardingContainerCharge: 'forwarding_charge',
  totalAgentCharge: 'agent_charge',
} as const;

export const shippingChargesMap = {
  totalFreightCharges: 'freight_charge',
  totalForwardingCharges: 'forwarding_charge',
  totalInsuranceCharges: 'insurance_charge',
} as const;

export const costsArray = [
  // container cost
  'totalAgentCharge',
  'totalForwardingContainerCharge',
  'totalLoadingCharge',
  'BLFE',
  'DMRG',
  'DRYG',
  'DTNT',
  'OTPC',
  'OTSA',
  'PACK',
  'THCC',
  'CSFE',
  // shipment cost
  'totalForwardingCharges',
  'totalFreightCharges',
  'totalInsuranceCharges',
] as const;

export const invoiceSections = {
  //prepare
  billTo: 'bill-to',
  shipTo: 'ship-to',
  importantDetails: 'important-details',

  //additional info
  shipInfo: 'ship-info',
  addInfo: 'additional-info',
  paymentMode: 'payment-mode',

  //add carriers
  summary: 'summary',
  addCarriers: 'add-carriers',
  carriersList: 'carriers-list',
  totals: 'totals',
} as const;

export const invoicePages = {
  prepare: 'prepare',
  additionalInfo: 'additionalInfo',
  addCarriers: 'addCarriers',
  previewSend: 'previewSend',
} as const;

export const InvoiceTypesObj = {};

export const selectableDescriptionParams = [
  // keys of carrier in shipment details for instructions and invoice api except paired values like make-model
  'transmission',
  'traction',
  'powerCC',
  'energyKW',
  'kilometers',
  'fuelType',
  'make-model',
  'model',
  'chModelShort-chNumShort',
  'modelCode',
  'carrying_wt',
  'gross_wt',
  'regYShort-regMShort',
  'ext_colour',
  'category',
  'exportCategory',
  'net_wt',
] as const;

export const selectableCosts = [
  'forwardingCharge',
  'insuranceCharge',
  'freightCharge',
];

export const selectableRowsMap: Record<
  (typeof selectableDescriptionParams)[number],
  string
> = {
  // mapping translations
  transmission: 'transmission',
  traction: 'traction',
  powerCC: 'power_cc',
  energyKW: 'power_kw',
  kilometers: 'drive_km',
  fuelType: 'fuel_type',
  'make-model': 'make-model',
  'chModelShort-chNumShort': 'chassis_model-chassis_number',
  modelCode: 'model_code',
  carrying_wt: 'carrying_wt',
  gross_wt: 'gross_wt',
  'regYShort-regMShort': 'reg_year-reg_month',
  ext_colour: 'colour',
  category: 'category',
  exportCategory: 'export_category',
  model: 'model',
  net_wt: 'net_wt',
} as const;

export const CustomerInvoiceTypes: cit[] = [
  'commercial',
  'proforma',
  'temporary',
];

export const mapInvoiceType = {
  proforma: 'proformaBtnLabel',
  commercial: 'commercialBtnLabel',
  temporary: 'tempCommercialBtnLabel',
  temp_commercial: 'temporaryInvoice',
};

export const mapInvoiceTypeColor = {
  proforma: 'bg-indigo-800',
  commercial: 'bg-emerald-800',
  temp_commercial: 'bg-amber-700',
};

export const nonTT = ['all', 'lc'];
